window.RUNTIME_CONFIG = {
    PORTAL_LOGIN: 'http://localhost:8601/login'
};